import { render, staticRenderFns } from "./Evenement.vue?vue&type=template&id=67dd10e8&scoped=true"
import script from "./Evenement.vue?vue&type=script&lang=js"
export * from "./Evenement.vue?vue&type=script&lang=js"
import style0 from "./Evenement.vue?vue&type=style&index=0&id=67dd10e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd10e8",
  null
  
)

export default component.exports